/* Snackbars for project */
;
(function ($) {

    'use strict';

    /**
     * Store current instance
     */
    var instance;

    $.snackbar = function(content) {

        var snackbarsDiv = '<div class="m-snackbars-container"></div>';

        if (instance === undefined) {
            $('body').append(snackbarsDiv);
            $.snackbar.zIndex = 0;
        }

        // Set current instance
        instance = this;

        ++$.snackbar.zIndex;

        var duration = 800;
        var className = 'm-snackbar';

        var CID = Math.floor(Math.random() * 999999);
        var html = '<div class="'+ className +'" id="snackbar-' + CID + '"><div class="'+ className +'--inner">' + content + '</div></div>';
        var $snackbarsContainer = $('.m-snackbars-container');
        $snackbarsContainer.prepend(html);
        var $snackbar = $('#snackbar-' + CID);

        setTimeout(function () {
            $snackbar.css('z-index', $.snackbar.zIndex);
            $snackbar.velocity({
                opacity: [1, 0],
                bottom: 0
            }, 500);
        }, 10);

        setTimeout(function () {
            $snackbar.velocity({
                opacity: [0, 1],
                bottom: '-=100vh',
                complete: function () {
                    setTimeout(function () {
                        $snackbar.remove();
                    }, 1000);
                }
            }, 500);
        }, 2900);


        return instance;

    };

}(jQuery));